<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.warning }}</strong>
          </p>
        </template>
        <!-- <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow> -->
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaTanggalPenilaian-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalPenilaian" format="DD MMMM YYYY" required></date-picker>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button variant="info" class="mr-1" v-c-tooltip.hover.click="'Detail Data'" v-b-modal.modal-edit @click="data = item"><CIcon name="cil-print" /></b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-edit :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-input @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalEdit from "./modalEdit.vue";
import modalInput from "./modalInput.vue";

export default {
  components: {
    modalEdit,
    modalInput,
  },
  name: "penilaian",
  data() {
    return {
      data: {},
      items: [],
      filter: {
        tanggalPenilaian: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      return [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          _classes: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "tempatTugas",
          label: this.$store.state.table.tempatTugas,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "persetujuan",
          label: this.$store.state.table.status_persetujuan,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalPenilaian",
          label: this.$store.state.table.namaTanggalPenilaian,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "totalPoin",
          label: this.$store.state.table.totalPoin,
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _classes: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];
    },
  },
  mounted() {
    this.getDatas();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalPenilaian"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPenilaian = await vm.$axios.post("penilaianKinerja/listSatuBulanLaluPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      console.log("listPenilaian", listPenilaian);
      vm.items =
        listPenilaian.data.status == 200
          ? listPenilaian.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                persetujuan: x.persetujuanPenandatanganan ? "Setuju" : "Tidak Setuju",
                namaTanggalPenilaian: vm.$moment(x.tanggalPenilaian).format("LL"),
              };
            })
          : [];
      vm.totalRows = parseInt(listPenilaian.data.count);
      vm.loading = false;
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
